import React from "react";
import { Box, Button, Modal as MUIModal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const defaultStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  borderRadius: "20px",
  width: "90%",
  maxWidth: "800px",
};

const Modal = ({ open, onClose, children, style = {} }) => {
  return (
    <MUIModal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...defaultStyle, ...style }}>
        <Button
          onClick={onClose}
          sx={{
            position: "fixed",
            top: 20,
            right: 20,
            cursor: "pointer",
          }}
        >
          <CloseIcon />
        </Button>

        {children}
      </Box>
    </MUIModal>
  );
};

export default Modal;
